module.exports = __webpack_public_path__ + "static/pulsar-logo-white-c176eee4aaa8f6690ab57555098e8d23.png";